export function saveFile(fileName: string, mime: string, text: string) {
  const blob = new Blob([text], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 2000)
}

/** A leading BOM so Excel opens the file as UTF-8 rather than mangling accents. */
export const saveCsv = (fileName: string, body: string) =>
  saveFile(fileName, 'text/csv;charset=utf-8;', '﻿' + body)
